import dayjs, { type Dayjs } from 'dayjs'

/** ISO YYYY-MM-DD (или префикс) → dayjs начала дня; пусто/невалидно → null. */
export function parseIsoBirthdayToDayjs(iso?: string | null): Dayjs | null {
  if (iso == null || String(iso).trim() === '') return null
  const d = dayjs(String(iso).trim().slice(0, 10))
  return d.isValid() ? d.startOf('day') : null
}

/** Полных лет на указанную дату «сегодня» (по календарю). */
export function fullYearsSinceBirthday(birthday: Dayjs, today: Dayjs = dayjs()): number {
  const b = birthday.startOf('day')
  const t = today.startOf('day')
  let years = t.year() - b.year()
  const monthDiff = t.month() - b.month()
  if (monthDiff < 0 || (monthDiff === 0 && t.date() < b.date())) {
    years -= 1
  }
  return years
}

/** Минимальная допустимая дата рождения (100 лет на «сегодня»). */
export function minBirthdayDate(today: Dayjs = dayjs()): Dayjs {
  return today.subtract(100, 'year').startOf('day')
}

/** Максимальная допустимая дата рождения (14 лет на «сегодня»). */
export function maxBirthdayDate(today: Dayjs = dayjs()): Dayjs {
  return today.subtract(14, 'year').startOf('day')
}

/** Грубая оценка возраста по ISO-дате (для моков и отладки). */
export function approximateAgeFromBirthdayIso(iso: string): number {
  const parts = iso.split('-').map(Number)
  if (parts.length < 3 || parts.some((n) => Number.isNaN(n))) {
    return 0
  }
  const [py, pm, pd] = parts
  const birth = new Date(py, (pm ?? 1) - 1, pd ?? 1)
  const now = new Date()
  let age = now.getFullYear() - birth.getFullYear()
  const monthDiff = now.getMonth() - birth.getMonth()
  if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < birth.getDate())) {
    age -= 1
  }
  return age < 0 ? 0 : age
}
